"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useClient_1 = __importDefault(require("./useClient"));
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
const queryCache_1 = require("./queryCache");
const getHelpers_1 = __importDefault(require("./getHelpers"));
const handleError_1 = __importDefault(require("./handleError"));
const getResultPromise_1 = __importDefault(require("./getResultPromise"));
function useQueryBase(options) {
    const client = useClient_1.default(options.clientName);
    const observableQuery = options.omit
        ? null
        : queryCache_1.getCachedObservableQuery(client, options);
    const resultRef = react_1.useRef(null);
    const optionsRef = react_1.useRef(options);
    const forceUpdate = react_1.useReducer((x) => x + 1, 0)[1];
    const currResult = observableQuery?.getCurrentResult() ?? null;
    const result = options.omit ? null : currResult;
    const emptyResult = {
        data: {},
        loading: false,
        networkStatus: 0,
        error: undefined,
    };
    react_1.useEffect(() => {
        if (options.omit)
            return;
        const subscription = observableQuery?.subscribe((nextResult) => {
            if (!resultRef.current ||
                !react_fast_compare_1.default(resultRef.current.data, nextResult.data) ||
                resultRef.current.networkStatus !== nextResult.networkStatus) {
                forceUpdate();
            }
        });
        return () => {
            subscription?.unsubscribe();
            queryCache_1.invalidateCachedObservableQuery(client, options);
        };
    }, [queryCache_1.getCacheKey(options)]);
    if (options.omit)
        return emptyResult;
    if (!react_fast_compare_1.default(optionsRef.current, options)) {
        observableQuery?.setOptions(options);
    }
    if (!options.partial &&
        result?.partial &&
        options.fetchPolicy !== 'cache-only' &&
        observableQuery) {
        const promise = getResultPromise_1.default(observableQuery);
        throw promise;
    }
    resultRef.current = result ?? null;
    if (result?.errors && result?.errors.length) {
        if (options.handleError) {
            options.handleError(result, options);
        }
        else {
            handleError_1.default(result, options);
        }
    }
    let helpers = {};
    if (observableQuery) {
        helpers = getHelpers_1.default(observableQuery);
    }
    return {
        observableQuery,
        ...(result?.data ? result : emptyResult),
        ...helpers,
    };
}
exports.default = useQueryBase;
